import type { ReactNode } from 'react';
import CheckboxValueControl, { type ICheckboxValueControlProps } from '../CheckboxValueControl';

export type ICheckboxBitControlProps = Omit<
    ICheckboxValueControlProps<number>,
    'trueValue' | 'falseValue' | 'isChecked' | 'labelAdornment' | 'labelAsHtml'
> & {
    /** Значок подсказки у подписи (`labelAdornment` флажка) */
    tooltip?: ReactNode;
};

/** Бит с сервера приходит числом или строкой */
const isBitChecked = (value: unknown) => value === 1 || value === '1';

/** Флажок-бит: в поле формы — `1` или `0`; строковая подпись — разметка (подписи полей документа из конфигурации). */
const CheckboxBitControl = ({ tooltip, ...props }: ICheckboxBitControlProps) => (
    <CheckboxValueControl
        {...props}
        trueValue={1}
        falseValue={0}
        isChecked={isBitChecked}
        labelAdornment={tooltip}
        labelAsHtml
    />
);

export default CheckboxBitControl;
